// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const conwaysLaw: Law = {
  slug: "conways-law",
  title: "Conway’s Law",
  definition: "Any piece of software reflects the organizational structure that produced it.",
  category: "theory",
  color: "#ad65be",
  labels: ["architecture","software-engineering","management"],
  copy: ["Or even more clearly:","In many organizations teams are divided according to their functional skills. So you'll have teams of front-end developers, backend-developers and database developers. Simply stated, it's hard for someone to change something if the thing he/she wants to change is owned by someone else.","It is much better, and more and more implemented as such, to deploy teams around a bounded context. Architectures such as microservices structure their teams around service boundaries rather than siloed technical architecture partitions.","So, structure teams to look like your target architecture, and it will be easier to achieve it. That's how you defend against Conways's law."],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
